import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import store from './store';
import router from './router';
import i18n from './i18n';
import RedButton from './components/club/buttons/ButtonRed';
import BlueButton from './components/club/buttons/ButtonBlue';
import BluePanel from './components/club/panels/PanelBlue/PanelBlue';
import BluePanelDateTimePicker from './components/club/panels/PanelBlue/PanelBlueDateTimePicker';
import ClubLayout from './components/club/Layout';

// This installs <router-view> and <router-link>,
// and injects $router and $route to all router-enabled child components
Vue.use(VueRouter);

Vue.config.productionTip = false;

Vue.component('red-button', RedButton);
Vue.component('blue-button', BlueButton);
Vue.component('blue-panel', BluePanel);
Vue.component('blue-panel-date-time-picker', BluePanelDateTimePicker);
Vue.component('club-layout', ClubLayout);

new Vue({
  el: '#app',
  i18n,
  store,
  router,
  render: h => h(App)
}).$mount('#app');

